import { z } from 'zod';

export const UserAttributionPayloadSchema = z.object({
  referralId: z.string().max(120).optional(),
  utmSource: z.string().max(120).optional(),
  utmMedium: z.string().max(120).optional(),
  utmCampaign: z.string().max(120).optional(),
  utmContent: z.string().max(120).optional(),
  utmTerm: z.string().max(120).optional(),
  landingUrl: z.string().max(500).optional(),
});

export const SaveAttributionRequestSchema = UserAttributionPayloadSchema;

export const SaveAttributionResponseSchema = z.object({
  success: z.boolean(),
  attributionId: z.string().uuid().optional(),
});

export const UserAttributionResponseSchema = z.object({
  referralId: z.string().nullable(),
  utmSource: z.string().nullable(),
  utmMedium: z.string().nullable(),
  utmCampaign: z.string().nullable(),
  utmContent: z.string().nullable(),
  utmTerm: z.string().nullable(),
  landingUrl: z.string().nullable(),
  createdAt: z.string().datetime().nullable(),
});

export type UserAttributionPayload = z.infer<typeof UserAttributionPayloadSchema>;
export type SaveAttributionRequest = z.infer<typeof SaveAttributionRequestSchema>;
export type SaveAttributionResponse = z.infer<typeof SaveAttributionResponseSchema>;
export type UserAttributionResponse = z.infer<typeof UserAttributionResponseSchema>;
